import { render, staticRenderFns } from "./AdminMultiselect.vue?vue&type=template&id=647c3154&"
import script from "./AdminMultiselect.vue?vue&type=script&lang=js&"
export * from "./AdminMultiselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports